export default "__VITE_ASSET__CzHNiZae__"